import { render, staticRenderFns } from "./ColaboratorForm.vue?vue&type=template&id=20791b97"
import script from "./ColaboratorForm.vue?vue&type=script&lang=js"
export * from "./ColaboratorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports